import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import LicService from '../../../../../services/licitacao-auth';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [processo, setProcesso] = useState("");
    const [ano, setAno] = useState("");
    const [modalidade, setModalidade] = useState("");
    var situacao;
    props.situacao ? situacao = props.situacao : situacao = "Todas";


    const busca = async (query) => {
        if (query == "") {
            props.setAindaTem(true)
            await props.fetchLicsIn()
            setAno("")
            setProcesso("")
        } else {
            var response = await LicService.buscar(query)
            if (response.data.length >= 1) {
                props.setLics(response.data)
                props.setAindaTem(false)
                props.setVazio(false)
                setAno("")
                setProcesso("")
            } else {
                props.setVazio(true)
                setAno("")
                setProcesso("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (processo) prepQuery = prepQuery + `&processo=${processo}`;
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        if (situacao) prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        if (modalidade !== "false" && modalidade != "false" && modalidade !== "") prepQuery = prepQuery + `&modalidade=${encodeURI(modalidade)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Número">
                                <FloatingLabel
                                    label="Número do Processo (sem ano)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="processo"
                                        value={processo}
                                        onChange={e => setProcesso(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano do Processo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Modalidade">
                                <FloatingLabel
                                    label="Modalidade"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Modalidade"
                                        name="modalidade"
                                        onChange={e => setModalidade(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Carta Convite">Carta Convite</option>
                                        <option value="Concorrência">Concorrência</option>
                                        <option value="Concurso">Concurso</option>
                                        <option value="Leilão">Leilão</option>
                                        <option value="Pregão">Pregão</option>
                                        <option value="Pregão Eletrônico">Pregão Eletrônico</option>
                                        <option value="Tomada de Preço">Tomada de Preço</option>
                                        <option value="Dispensa">Dispensa</option>
                                        <option value="Inexigibilidade">Inexigibilidade</option>
                                        <option value="COVID">COVID</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/licitacao'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca